import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import DataOption from '../../models/DataOption';
import StatMessages from '../../StatMessages';
import ChartOption from '../../models/ChartOption';

const messages = defineMessages({
  CALLS_WAITING: {
    id: 'CALLS_WAITING',
    defaultMessage: 'Calls Waiting',
  },
});

export default class Callqueue {
  constructor(intl) {
    if (!intl) {
      throw Error('Missing intl param');
    }

    const statMessages = new StatMessages(intl);

    /**
     * add socket subscriptions and events if any
     * Example Props
     * stat: 'AC'
     * socketSubscriptions: [{ type: 'agent' }]
     * socketEvents: [{ name: string, adapter: function, adapterParams: object }] }
     * @type {*[]}
     */
    const supportedColumns = [
      { stat: 'CallerName', ...statMessages.messages.CallerName },
      { stat: 'CallerStatus', ...statMessages.messages.CallerStatus },
      { stat: 'CallerNumber', ...statMessages.messages.CallerNumber },
      { stat: 'CallerWaitTime', ...statMessages.messages.CallerWaitTime },
    ];

    /**
     * Displays chart options to the user
     * type: timeRange displays an input and sets the start/end for the api request
     * type: queueFilter displays an input and sets the queue/s for the api request
     */
    const chartOptions = [
      new ChartOption({
        type: 'columnList',
        required: true,
        columns: supportedColumns.map((column) => column.stat),
      }),
    ];

    this.dataOptions = new DataOption({
      type: 'socket',
      baseColumns: [],
      chartOptions,
      defaultColumns: ['CallerName', 'CallerNumber', 'CallerStatus', 'CallerWaitTime'],
      filterCategories: ['callqueue'],
      filterMultiples: true,
      hasCategories: false,
      hasColumns: true,
      liveData: true,
      label: <FormattedMessage {...messages.CALLS_WAITING} />,
      labelStr: intl.formatMessage({ ...messages.CALLS_WAITING }),
      socketEvents: [{ name: 'queued', adapter: 'queueSocketToTableAdapter' }], 
      socketSubscriptions: [{
        type: 'queued', filter: '*', unit: 'seconds',
      }],
      stat: 'Queued',
      supportedCharts: ['ResponsiveTable'],
      supportedColumns,
    });
  }
}
